import React from "react";
import { Table } from "react-bootstrap";

import { Subscribe } from "unstated";
import InvoiceDataContainer from "../Stores/InvoiceDataContainerStore";
import { myUtilities } from "../Utils";
import CompleteInvoiceDrawer from "./CompleteInvoiceDrawer";
import { renderCell } from "./partialPaymentHelpers";

const extractViewMoreButton = (state) => {
	if(state.selectedInvoices) {
  if (state?.selectedInvoices?.length <= 3)
    return myUtilities.accountSpecificLanguage(
      "invoicegrid.moreDetails",
      "more details"
    );
  else
    return (
      <>
        + {state?.invoices?.length - 3}{" "}
        {myUtilities.accountSpecificLanguage(
          "invoicegrid.moreInvoices",
          "more invoices"
        )}
      </>
    );
    }
};

const InvoiceTableMUX = ({showDrawer, setShowDrawerFlag}) => {

  return (
    <Subscribe to={[InvoiceDataContainer]}>
      {(invData) => (
        <>
          <Table responsive="sm" size="sm">
            <thead>
              <tr className="table-header">
                {invData.state.gridFields &&
                  invData.state.gridFields?.slice(0, 4).map((item, idx) => (
                    <th key={idx}>
                      {myUtilities.accountSpecificLanguage(
                        "invoicegrid.header.label." + item[0],
                        item[1]
                      )}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {invData.state.selectedInvoices &&
                invData.state.selectedInvoices.slice(0, 3).map((invoiceItem, idx) => (
                  <tr key={idx}>
                    {invData.state.gridFields &&
                      invData.state.gridFields?.slice(0, 4).map((item, idxSub) =>
                        renderCell(item, idxSub, invoiceItem, invData)
                      )}
                  </tr>
                ))}
              {invData.state.selectedInvoices && (
                <tr>
                  <td onClick={()=>setShowDrawerFlag(true)} className="view-more-btn" colSpan="4">
                   {extractViewMoreButton(invData.state)}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <CompleteInvoiceDrawer
            showDrawer={showDrawer}
            setShowDrawerFlag={setShowDrawerFlag}
            invData = {invData}
          />
        </>
      )}
    </Subscribe>
  );
};

export default InvoiceTableMUX;
